import React from "react";
import classNames from "classnames";
import ReactTooltip from "react-tooltip";

const CircularIconButton = ({
  className = "",
  icon = "",
  onClick = (f) => f,
  tooltip,
  tooltipPlacement = "top",
  ...props
}) => {
  return (
    <>
      <button
        className={classNames("px-2 py-1 btn btn-icon-circle", className)}
        onClick={onClick}
        data-tip={tooltip}
        data-place={tooltipPlacement}
        data-effect={"solid"}
        {...props}
      >
        <i className={icon}></i>
      </button>
      {tooltip && <ReactTooltip />}
    </>
  );
};

export default CircularIconButton;
